"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import cnBind from "classnames/bind";
import { useTranslation } from "react-i18next";

import { Routes } from "@/shared/constants/Routing";
import { trackMarketing } from "@/components/marketing/launch";

import styles from "./TurnkeyLaunchTeaser.module.scss";

const cx = cnBind.bind(styles);

export function TurnkeyLaunchTeaser() {
    const { t } = useTranslation("common");

    return (
        <section className={cx("root")} aria-label={t("home.turnkeyTeaser.ariaLabel")}>
            <div className={cx("inner")}>
                <div className={cx("copy")}>
                    <span className={cx("eyebrow")}>{t("home.turnkeyTeaser.eyebrow")}</span>
                    <h2 className={cx("title")}>{t("home.turnkeyTeaser.title")}</h2>
                    <p className={cx("lead")}>{t("home.turnkeyTeaser.lead")}</p>
                    <p className={cx("meta")}>
                        <strong>{t("home.turnkeyTeaser.meta")}</strong>
                    </p>
                    <p className={cx("note")}>{t("home.turnkeyTeaser.note")}</p>
                </div>
                <Link
                    href={Routes.TURNKEY_LAUNCH}
                    className={cx("cta")}
                    onClick={() => trackMarketing("turnkey_teaser_cta", { source: "home_after_tariffs" })}
                >
                    {t("home.turnkeyTeaser.cta")}
                    <ArrowRight size={18} aria-hidden />
                </Link>
            </div>
        </section>
    );
}
